export const compressString = async (input: string): Promise<string> => {
  const cs = new CompressionStream("gzip");
  const encoder = new TextEncoder();
  const data = encoder.encode(input);
  const readable = new ReadableStream({
    start(controller) {
      controller.enqueue(data);
      controller.close();
    },
  });
  const compressedReadable = readable.pipeThrough(cs);
  const compressedData = new Uint8Array(
    await new Response(compressedReadable).arrayBuffer(),
  );
  let binary = "";
  const len = compressedData.byteLength;
  for (let i = 0; i < len; i++) {
    binary += String.fromCharCode(compressedData[i]);
  }
  return window.btoa(binary);
};

export const decompressString = async (input: string): Promise<string> => {
  const ds = new DecompressionStream("gzip");
  const data = Uint8Array.from(atob(input), (c) => c.charCodeAt(0));
  const readable = new ReadableStream({
    start(controller) {
      controller.enqueue(data);
      controller.close();
    },
  });
  const decompressedReadable = readable.pipeThrough(ds);
  const response = new Response(decompressedReadable);
  const buf = await response.arrayBuffer();
  return new TextDecoder().decode(buf);
};
